<template>
    <modal-component
        :id="'patient-receipt-modal'"
        :visible="isVisible"
        :size="'lg'"
        :title="'Patient Receipt'"
        @close="resetModal()"
    >
        <div id="receiptPrint" class="p-3">
            <div class="row">
                <div class="col-4">
                    <div class="center-logo" v-if="organization.logo_path">
                        <img
                            :src="organization.logo_path.replace('public', '/storage')"
                            class="img-fluid invoice-logo"
                        />
                    </div>
                    <h6>{{ organization.name }}</h6>
                    <h6>{{ organization.address }}</h6>
                    <h6>{{ organization.primary_phone }}</h6>
                </div>
                <div class="col-4">
                    <h2>Patient Receipt</h2>
                    <p class="small">
                        Service Date Range: <br />
                        {{ payload.start_at ? moment(payload.start_at).format("MM/DD/YYYY") : "" }}
                        - {{ payload.end_at ? moment(payload.end_at).format("MM/DD/YYYY") : "" }}
                    </p>
                </div>
                <div class="col-4">
                    <p class="text-right mb-0">{{ moment().format("MM/DD/YYYY") }}</p>
                    <p class="text-right mb-0" data-private="lipsum">
                        {{ helpers._get(receipt, "patient.name", "") }}
                    </p>
                    <p class="text-right mb-0" data-private="lipsum">
                        {{ helpers._get(receipt, "patient.addresses.0.address1", "") }}
                        {{ helpers._get(receipt, "patient.addresses.0.city", "") }}
                        {{ helpers._get(receipt, "patient.addresses.0.state", "") }}
                    </p>
                    <p class="text-right mb-0">
                        {{ helpers._get(receipt, "patient.primary_phone", "") }}
                    </p>
                    <p class="text-right mb-0">
                        {{ helpers._get(receipt, "patient.parent_email", "") }}
                    </p>
                </div>
            </div>

            <table class="table table-sm table-striped mt-5">
                <thead class="thead-dark">
                    <tr>
                        <th colspan="6">
                            <span class="d-flex justify-content-center font-weight-bold w-100"
                                >Charges</span
                            >
                        </th>
                    </tr>
                    <tr>
                        <th class="">Service Date</th>
                        <!--
                                    <th class="">Location</th>
                    -->
                        <!--TODO: not in payload-->
                        <!--
                                    <th class="">Therapist</th>
                    -->
                        <!--TODO: not in payload-->
                        <th class="">Code/Description</th>
                        <th class="">Funding Source</th>
                        <th class="text-right">Amount</th>
                        <th class="text-right">Paid</th>
                        <th class="text-right">Balance</th>
                    </tr>
                </thead>
                <tbody class="">
                    <tr v-for="charge in receipt.charges">
                        <td class="">{{ formatDate(charge.serviced_at) }}</td>
                        <!--<td class="">{{locationKey(charge.service_location)}}</td>--><!--TODO: not in payload-->
                        <!--<td class="">{{charge.therapist_name}}</td> --><!--TODO: not in payload-->
                        <td>
                            <template v-if="charge.hasOwnProperty('cpt_codes')">
                                <span v-for="code in charge.cpt_codes">{{ code }}</span>
                            </template>
                            <template v-if="charge.hasOwnProperty('service_codes')">
                                <span v-for="code in charge.service_codes">{{ code }}</span>
                            </template>
                        </td>
                        <td>
                            {{ charge.funding_source }}
                            <!--TODO: not in payload-->
                        </td>
                        <td class="text-right">
                            {{ helpers.formatMoney(charge.expected_amount) }}
                        </td>
                        <td class="text-right">
                            {{ helpers.formatMoney(charge.paid_amount) }}
                        </td>
                        <td
                            class="text-right"
                            :class="{ 'text-danger': charge.expected_amount - charge.paid_amount }"
                        >
                            {{ helpers.formatMoney(charge.expected_amount - charge.paid_amount) }}
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="font-weight-bold">
                        <!--
                                            <td colspan="5"></td>
                    -->
                        <td colspan="3"></td>
                        <td class="text-right">{{ helpers.formatMoney(chargesTotalExpected) }}</td>
                        <td class="text-right">{{ helpers.formatMoney(chargesTotalPaid) }}</td>
                        <td class="text-right">
                            {{ helpers.formatMoney(chargesTotalExpected - chargesTotalPaid) }}
                        </td>
                    </tr>
                </tfoot>
            </table>

            <table class="table table-sm table-striped mt-5">
                <thead class="thead-dark">
                    <tr>
                        <th colspan="7">
                            <span class="d-flex justify-content-center font-weight-bold"
                                >Payments</span
                            >
                        </th>
                    </tr>
                    <tr>
                        <th class="">Payment Date</th>
                        <!--
                                            <th class="">Funding Source</th>
                    -->
                        <!--TODO: not in payload-->
                        <th class="">Payment Type</th>
                        <th class="">Notes</th>
                        <th class="text-right">Amount</th>
                        <th class="text-right">Allocated</th>
                        <th class="text-right">Payment Balance</th>
                    </tr>
                </thead>
                <tbody class="">
                    <tr v-for="payment in receipt.payments">
                        <td class="">{{ formatDate(payment.created_at) }}</td>
                        <!--<td class="">{{payment.funding_source}}</td>-->
                        <!--TODO: not in payload-->
                        <td class="">{{ prettyPaymentType(payment.type) }}</td>
                        <td class="">{{ payment.notes }}</td>
                        <td class="text-right">{{ helpers.formatMoney(payment.amount) }}</td>
                        <td class="text-right">{{ helpers.formatMoney(payment.allocated) }}</td>
                        <td class="text-right">{{ helpers.formatMoney(payment.balance) }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="font-weight-bold">
                        <!--
                                            <td colspan="4"></td>
                    -->
                        <td colspan="3"></td>
                        <td class="text-right">{{ helpers.formatMoney(paymentTotalAmount) }}</td>
                        <td class="text-right">{{ helpers.formatMoney(paymentTotalAllocated) }}</td>
                        <td class="text-right">
                            {{ helpers.formatMoney(paymentTotalAmount - paymentTotalAllocated) }}
                        </td>
                    </tr>
                </tfoot>
            </table>

            <table class="table table-sm table-striped mt-5">
                <thead class="thead-dark">
                    <tr>
                        <th colspan="5">
                            <span class="d-flex justify-content-center font-weight-bold"
                                >Balance Summary</span
                            >
                        </th>
                    </tr>
                    <tr>
                        <th class="">Funding Source</th>
                        <th class="">Address</th>
                        <!--
                                        <th class="">Phone Number</th>
                    -->
                        <!--TODO: not in payload-->
                        <th class="">Paid</th>
                        <th class="">Billed</th>
                        <th class="">Balance</th>
                    </tr>
                </thead>
                <tbody class="">
                    <tr v-for="source in receipt.balance_summary">
                        <td class="">{{ source.name }}</td>
                        <td class="">
                            {{ helpers._get(source, "address.address1", "") }}
                            {{ helpers._get(source, "address.city", "") }}
                            {{ helpers._get(source, "address.state", "") }}
                        </td>
                        <!--<td class="">{{source.primary_phone}}</td>--><!--TODO: not in payload-->
                        <td class="text-right">{{ helpers.formatMoney(source.paid) }}</td>
                        <td class="text-right">{{ helpers.formatMoney(source.billed) }}</td>
                        <td class="text-right">{{ helpers.formatMoney(source.balance) }}</td>
                    </tr>
                </tbody>
            </table>

            <h6 class="my-3 text-center">
                All balances listed above will include all charges and payments associated to this
                patient.
            </h6>

            <table class="w-100">
                <tr>
                    <td>
                        <table class="table table-sm table-striped mt-5">
                            <thead class="thead-dark">
                                <tr>
                                    <th colspan="2">
                                        <span class="d-flex justify-content-center font-weight-bold"
                                            >Location Legend</span
                                        >
                                    </th>
                                </tr>
                                <tr>
                                    <th class="">#</th>
                                    <th class="">Address</th>
                                    <!--
                                                                <th class="">Phone Number</th>
                                -->
                                    <!--TODO: not in payload-->
                                </tr>
                            </thead>
                            <tbody class="">
                                <tr v-for="(address, index) in receipt.addresses">
                                    <td class="">{{ index + 1 }}</td>
                                    <td class="">{{ address }}</td>
                                    <!--<td class=""></td>--><!--TODO: not in payload-->
                                </tr>
                            </tbody>
                        </table>
                    </td>
                    <td class="">
                        <div
                            class="w-100 d-flex justify-content-center align-items-center font-weight-bold"
                        >
                            <h5>Patient Due: {{ helpers.formatMoney(balanceSummaryBalance) }}</h5>
                        </div>
                    </td>
                </tr>
            </table>
        </div>

        <div class="d-flex w-100 justify-content-end">
            <button class="btn btn-sm btn-primary" @click="helpers.printElement('receiptPrint')">
                Print
            </button>
        </div>
    </modal-component>
</template>

<script>
import ModalComponent from "../ui/ModalComponent";
export default {
    name: "PatientReceipt",
    props: ["payload", "organization"],
    data() {
        return {
            isVisible: false,
            receipt: {},
        };
    },
    components: {
        ModalComponent,
    },
    computed: {
        chargesTotalExpected() {
            return this.receipt && this.receipt.charges && this.receipt.charges.length
                ? this.receipt.charges.reduce((acc, cur) => acc + cur.expected_amount, 0)
                : 0;
        },
        chargesTotalPaid() {
            return this.receipt && this.receipt.charges && this.receipt.charges.length
                ? this.receipt.charges.reduce((acc, cur) => acc + cur.paid_amount, 0)
                : 0;
        },
        paymentTotalAmount() {
            return this.receipt && this.receipt.payments && this.receipt.payments.length
                ? this.receipt.payments.reduce((acc, cur) => acc + parseFloat(cur.amount), 0)
                : 0;
        },
        paymentTotalAllocated() {
            return this.receipt && this.receipt.payments && this.receipt.payments.length
                ? this.receipt.payments.reduce((acc, cur) => acc + parseFloat(cur.allocated), 0)
                : 0;
        },
        balanceSummaryBalance() {
            return this.receipt &&
                this.receipt.balance_summary &&
                this.receipt.balance_summary.length
                ? this.receipt.balance_summary.reduce((acc, cur) => acc + cur.balance, 0)
                : 0;
        },
    },
    methods: {
        locationKey(location) {
            let loc = this.receipt.addresses.find(loc => loc === location);
            return loc ? loc.key : "?";
        },
        resetModal() {
            this.receipt = {};
            this.isVisible = false;
        },
        formatDate(date) {
            return date ? this.moment(date).format("MM/DD/YYYY") : "";
        },
        prettyPaymentType(type) {
            switch (type) {
                case "cc":
                    return "Credit card";
                case "cof":
                    return "Card on file";
                case "cash":
                    return "Cash";
                case "check":
                    return "Check";
                default:
                    return type;
            }
        },
    },
};
</script>

<style scoped></style>
